
        var result = require("!!../../../../node_modules/css-loader/index.js!./products.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/products/products.component.css
// module id = 516
// module chunks = 0